export default __webpack_public_path__ + "static/cohorts-page-dark-mode-bf8871af3b258190267d637f49090433.png";